<form [formGroup]="updateFirmwareForm" (ngSubmit)="handleFormSubmit()">
  <h2 mat-dialog-title>{{ 'UPDATE_FIRMWARE' | translate }}</h2>

  <mat-dialog-content>
    @if (!updateFirmwareForm.controls.manualFirmware.value) {
      <mat-form-field class="w-full">
        <mat-label>{{ 'USE_EXISTING_FIRMWARE' | translate }}</mat-label>
        <mat-select formControlName="BoxUpdate">
          <mat-select-trigger>
            {{ updateFirmwareForm.controls.BoxUpdate.value?.FirmwareVersion || '' }}
          </mat-select-trigger>
          @for (item of boxUpdates; track item.PK_UpdateID) {
            <mat-option [value]="item">
              <div class="mb-2">{{ item.FirmwareVersion }}</div>
              <small class="break-all leading-tight text-gray-500">
                {{ item?.Link }}
              </small>
            </mat-option>
          }
        </mat-select>
        @if (canAddFirmware) {
          <button
            matSuffix
            mat-icon-button
            class="toolbar-button ml-1"
            type="button"
            *canSee="[userType.Admin, userType.BoxManufacturer]"
            (click)="$event.stopPropagation(); addFirmwareDialog()">
            <mat-icon>add</mat-icon>
          </button>
        }
        <mat-error>{{ 'REQUIRED' | translate }}</mat-error>
      </mat-form-field>

      @if (updateFirmwareForm.controls.BoxUpdate?.value && updateFirmwareForm.controls.BoxUpdate?.value.ReleaseNotes) {
        <mat-card appearance="outlined" class="mt-4">
          <mat-card-header class="mat-mdc-card-header--border !pb-4">
            <mat-card-title>
              <mat-icon class="align-text-bottom">difference</mat-icon>
              {{ 'RELEASE_NOTES' | translate }} •
              {{ updateFirmwareForm.controls.BoxUpdate?.value.FirmwareVersion }}
            </mat-card-title>
            @if (updateFirmwareForm.controls.BoxUpdate?.value.ReleaseDate) {
              <mat-card-subtitle>
                {{ $safeNavigationMigration(updateFirmwareForm.controls.BoxUpdate?.value.ReleaseDate) | cDate: 'L' }}
              </mat-card-subtitle>
            }
          </mat-card-header>
          <mat-card-content class="max-h-80 overflow-y-auto prose">
            <div [innerHTML]="$safeNavigationMigration(updateFirmwareForm.controls.BoxUpdate?.value.ReleaseNotes) | markdown | async"></div>
          </mat-card-content>
        </mat-card>
      }
    }

    @if (canSendCustomFirmware) {
      @if (!updateFirmwareForm.controls.manualFirmware?.value && !updateFirmwareForm.controls.BoxUpdate?.value) {
        <sc-divider horizontal>{{ 'OR' | translate }}</sc-divider>
      }

      @if (!updateFirmwareForm.controls.BoxUpdate?.value) {
        <mat-slide-toggle formControlName="manualFirmware" class="my-4">
          {{ 'CUSTOM_FIRMWARE_UPDATE' | translate }}
        </mat-slide-toggle>
      }
    }

    @if (updateFirmwareForm.controls.manualFirmware.value) {
      <mat-form-field floatLabel="auto" class="w-full">
        <mat-label>{{ 'URL' | translate }}</mat-label>
        <input matInput type="text" formControlName="URLFirmware" />
        <mat-error scError controlName="URLFirmware"></mat-error>
      </mat-form-field>

      <mat-form-field floatLabel="auto" class="w-full">
        <mat-label>{{ 'SIGNING_CERTIFICATE' | translate }}</mat-label>
        <textarea matInput formControlName="SigningCertificate" cols="10" rows="4"></textarea>
        <button
          mat-icon-button
          matSuffix
          class="input-helper"
          type="button"
          matTooltip="{{ 'SIGNING_CERTIFICATE_HELP' | translate }}">
          <mat-icon>help_outline</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field floatLabel="auto" class="w-full">
        <mat-label>{{ 'SIGNATURE' | translate }}</mat-label>
        <textarea matInput formControlName="Signature" cols="10" rows="4"></textarea>
      </mat-form-field>
    }

    @if (canSchedule) {
      <div class="mt-4">
        <mat-form-field class="mr-4">
          <mat-label>{{ 'SCHEDULE_INSTALL' | translate }}</mat-label>
          <input matInput type="datetime-local" formControlName="installDate" />
          <mat-hint>UTC</mat-hint>
          <mat-error scError controlName="installDate"></mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'SCHEDULE_DOWNLOAD' | translate }}</mat-label>
          <input matInput type="datetime-local" formControlName="retrieveDate" />
          <mat-hint>UTC</mat-hint>
          <mat-error scError controlName="retrieveDate"></mat-error>
        </mat-form-field>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button color="primary" type="submit">
      {{ 'UPDATE_FIRMWARE' | translate }}
    </button>
    <button mat-raised-button (click)="this.dialogRef.close()" type="button">
      {{ 'CANCEL' | translate }}
    </button>
  </mat-dialog-actions>
</form>
